import * as actions from '../actions/';
import { IRolesContext } from '../state/IRolesContext';
import { SystemRoleType } from '../../models/SystemRoleType';

export const initialState: IRolesContext = {
  jobFunctions: [],
  taskGroups: [],
  tasks: [],
  permissions: []
}

export function rolesContextReducer(state = initialState, action: actions.Actions): IRolesContext {
  switch (action.type) {
    case actions.QUERY_AVAILABLE_ROLES_BY_TYPE_SUCCESS:
      var queryAction = action as actions.QueryAvailableRolesByTypeSuccessAction;
      switch (queryAction.roleType) {
        case SystemRoleType.JobFunction:
          return { ...state, jobFunctions: queryAction.payload.items }
        case SystemRoleType.TaskGroup:
          return { ...state, taskGroups: queryAction.payload.items }
        case SystemRoleType.Task:
          return { ...state, tasks: queryAction.payload.items }
      }
    case actions.QUERY_AVAILABLE_PERMISSIONS_SUCCESS:
      var permissionQueryAction = action as actions.QueryAvailablePermissionsSuccessAction;
      return {
        ...state,
        permissions: permissionQueryAction.payload.items
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/security/store/reducers/roles-context.reducer.ts